import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { OrderByPipe } from '../../../pipes/order-by.pipe';

@Component({
  selector: 'app-contribuente-stipendi',
  templateUrl: './contribuente-stipendi.component.html',
  styleUrls: ['./contribuente-stipendi.component.css']
})
export class ContribuenteStipendiComponent implements OnInit {
	@ViewChild('stipModal') stipModal: ModalDirective;
	@Input() data : any = null;
	@Input() writePermission: boolean = false;

    constructor() { }

    ngOnInit() {
    }

}
